"use client";

import Link from "next/link";
import { useLocale } from "@/lib/useLocale";
import { t } from "@/lib/translations";

export default function Footer() {
  const { locale } = useLocale();
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { key: "nav.products", href: "/products" },
    { key: "nav.certifications", href: "/certifications" },
    { key: "nav.faq", href: "/faq" },
    { key: "footer.exportInquiry", href: "/export-inquiry" },
  ];

  return (
    <footer className="bg-white border-t border-slate-100">
      <div className="container mx-auto px-6 py-12">
        <div className="flex flex-col items-center text-center">
          <Link
            href="/"
            className="flex flex-col items-center mb-8"
          >
            <span className="text-2xl font-bold font-display text-slate-900 tracking-tight">
              Citra Marvella<span className="text-gold-500">.</span>
            </span>
            <span className="text-sm font-normal text-slate-500 tracking-normal mt-1">
              {t(locale, "footer.tagline")}
            </span>
          </Link>

          <nav className="flex flex-wrap justify-center gap-x-8 gap-y-2 mb-8">
            {footerLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-sm text-slate-600 hover:text-brand-600 transition-colors min-h-[44px] flex items-center"
              >
                {t(locale, link.key)}
              </Link>
            ))}
          </nav>

          <div className="flex flex-col sm:flex-row items-center gap-4 text-sm text-slate-500 mb-8">
            <a
              href="mailto:info@citramarvella.com"
              className="hover:text-brand-600 transition-colors"
            >
              info@citramarvella.com
            </a>
            <span className="hidden sm:inline text-slate-300">|</span>
            <a
              href="https://wa.me/6285111218008"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-brand-600 transition-colors"
            >
              +62 851-1121-8008
            </a>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-6 mt-2 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-slate-400">
          <p>&copy; {currentYear} citramarvella.com. {t(locale, "footer.copyright")}</p>
          <p>{t(locale, "footer.builtFor")}</p>
        </div>
      </div>
    </footer>
  );
}
